export const STORAGE_SEARCHES_KEY = 'tadarida_STORAGE_SEARCHES_KEY_V2';
